import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigator } from "../lib/navigation";

// Mounted once inside <Router> so non-React code (the axios interceptor) can navigate.
function NavigationSetter() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  return null;
}

export default NavigationSetter;
